import type { IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import { resetFormPatch } from './formReset';
import { withWidths } from './formWidths';
import type { IFormScope } from './IFormScope';
import { hasForms } from './scopeForm';

/** Патч без форми: без `forms` і явних ширин полів (решта — назви, поля, подання — лишається); порожній — null. Чиста функція. */
export function withoutForm(patch: IRecordTypeOverride): IRecordTypeOverride | null {
  const { forms: _forms, ...rest } = withWidths(patch, {});
  return Object.keys(rest).length ? rest : null;
}

/**
 * Патч після скидання форми за рівнем (прототип v4 feReset): глобальна форма вилучається цілком — знову діє опубліковане визначення
 * («Скинути до стандартного»); у просторі з глобальною формою («Використати глобальну форму») вилучаються всі форми простору — діє глобальна;
 * інакше — «Скинути до стандартного» простору (resetFormPatch). null — перевизначення вилучити. Чиста функція.
 */
export function scopeResetPatch(patch: IRecordTypeOverride, rt: IRecordTypeDefinition, published: IRecordTypeDefinition | undefined, scope: IFormScope):
  IRecordTypeOverride | null {
  if (scope.global || hasForms(scope.inherited)) return withoutForm(patch);
  return resetFormPatch(patch, rt, published);
}

/** Значення з ключами об'єктів за абеткою на всіх рівнях — щоб порівнювати патчі без огляду на порядок ключів. Чиста функція. */
const canonical = (value: unknown): unknown => (Array.isArray(value) ? value.map(canonical)
  : value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort().map((k) => [k, canonical((value as Record<string, unknown>)[k])]))
    : value);

/**
 * Чи змінить скидання форми патч свого рівня (scopeResetPatch). Засіяна прототипом картка парламенту, якої не змінював редактор, уже є
 * стандартом свого простору (скидання повертає ті самі групи), тож кнопки скидання для неї немає; з глобальною формою — «Використати
 * глобальну форму» вилучає форму простору (рішення 2 етапу 10). Чиста функція.
 */
export function resetChanges(patch: IRecordTypeOverride, rt: IRecordTypeDefinition, published: IRecordTypeDefinition | undefined, scope: IFormScope): boolean {
  return JSON.stringify(canonical(scopeResetPatch(patch, rt, published, scope))) !== JSON.stringify(canonical(patch));
}
